import { SearchOutlined, UndoOutlined } from '@ant-design/icons';
import { Button, Card, Col, DatePicker, Form, Input, Modal, Radio, Row, Select, Space, Table, message } from 'antd';
import { ColumnType, ColumnsType } from 'antd/es/table';
import { FilterConfirmProps } from 'antd/es/table/interface';
// import { DesignationDto, EmployeePayBillAllowanceEnum, EmployeePayBillDeductionEnum, EmployeePayBillTypeEnum, EmployeePayableMonth, PayrollComponentsDto, PayrollEntriesDto, PayrollProcessChildDto } from 'libs/shared-models';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import Highlighter from "react-highlight-words";
import { EmployeeService } from '@gtpl/shared-services/masters'
import { PayrollProcessServices } from '@gtpl/shared-services/hrms'
import { PayrollComponentsDto } from 'libs/shared-models/hrms/src/lib/payroll-process/payroll-components.dto';
import { EmployeePayBillAllowanceEnum, EmployeePayBillDeductionEnum, EmployeePayBillTypeEnum, PayrollRequestEmp, workerPayBillAllowanceEnum } from '@gtpl/shared-models/hrms';

interface DataItem {
    key: string;
    name: string;
    age: number;
    address: string;
    inputAmountValue: string;
    inputPercentValue: string;
    dateValue: string | null;
    radioValue: string | null;
}

export const EmployeePayable = () => {

    const service = new EmployeeService();
    const payrollService = new PayrollProcessServices()
    const [sourcingForm] = Form.useForm();
    const { Option } = Select;
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [saveData, setSaveData] = useState<any>([])
    const [rowData, setRowData] = useState<any[]>();
    const [paybillType, setPaybillType] = useState<string>("");
    // const [allowPercent, setAllowPercent] = useState<boolean>(false);
    const [allowAmount, setAllowAmount] = useState<boolean>(false);
    // const [deductPercent, setDeductPercent] = useState<boolean>(false);
    const [deductAmount, setDeductAmount] = useState<boolean>(false);
    // const [date, setDate] = useState<boolean>(false);
    const [amountPercentData, setAmountPercentData] = useState<string>("");
    const years = Array.from({ length: 20 }, (_, index) => new Date().getFullYear() - index);
    const [enteredAmount, setEnteredAmount] = useState("");
    const [searchedText, setSearchedText] = useState<any>([])
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    // const searchInput = useRef<InputRef>(null);
    const [page, setPage] = useState<number>(1);
    const [finishModal, setFinishModal] = useState<boolean>(false);
    // const [terms, setTerms] = useState<boolean>(false)
    const [ratio, setRatio] = useState<boolean>(false)
    const [paybillOptions, setPaybillOptions] = useState([]);
    const [hra, setHra] = useState<boolean>(false);
    const [hraAmount, setHraAmount] = useState("");
    const [showCategory, setShowCategory] = useState(false);
    const searchInput = useRef(null);
    const [ departData, setDepartData ] = useState<any[]>([])


    let createdUser = '';
    createdUser = localStorage.getItem('createdUser');

    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: string,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
    };





    const handleGridInputChange = (value, record) => {
        const updatedData = rowData.map((item) => {
            return item.employeeId === record.employeeId ? { ...item, inputAmountValue: value } : item;
        });

        setRowData(updatedData);
    };


    const getColumnSearchProps = (dataIndex: string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : false,
        onFilterDropdownVisibleChange: visible => {
            if (visible) { setTimeout(() => searchInput.current.select()); }
        },
        render: text =>
            text ? (
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text.toString()}
                    />
                ) : text
            )
                : null

    });

    const columns: ColumnsType<any> = [
        {
            title: 'S No',
            key: 'sno',
            width: '70px',
            responsive: ['sm'],
            render: (text, object, index) => (index + 1)
        },
        {
            title: 'Employee Code',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            sorter: (a, b) => a.employeeCode?.localeCompare(b?.employeeCode) - b.employeeCode?.localeCompare(a?.employeeCode),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('employeeCode')

        },
        {
            title: 'Employee Name',
            dataIndex: 'fullName',
            key: 'fullName',
            sorter: (a, b) => a.fullName?.localeCompare(b?.fullName) - b.fullName?.localeCompare(a?.fullName),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('fullName')
        },
        {
            title: 'Designation',
            dataIndex: 'designationName',
            key: 'designationName',
            sorter: (a, b) => a.designationName?.localeCompare(b?.designationName) - b.designationName?.localeCompare(a?.designationName),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('designationName')

        },
        {
            title: 'Department',
            dataIndex: 'departmentsId',
            key: 'departmentsId',
            sorter: (a, b) => a.departmentsId?.localeCompare(b?.departmentsId) - b.departmentsId?.localeCompare(a?.departmentsId),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('departmentsId')

        },
        {
            title: 'Value',
            dataIndex: 'inputAmountValue',
            key: 'inputAmountValue',
            render: (_, record) => (
                <Input
                    placeholder='enter amount'
                    value={record.inputAmountValue}
                    onChange={(e) => handleGridInputChange(e.target.value, record)}
                />
            ),
        },

    ];

    const handleRowSelection = (selectedKeys: React.Key[], selectedRows: DataItem[]) => {
        setSelectedRowKeys(selectedKeys);
        const updatedData = rowData.map((item) => {
            const isSelected = selectedKeys.includes(item.employeeId);
            if (isSelected) {
                // If the row is newly selected, set the input values
                return {
                    ...item,
                    inputAmountValue: item.inputAmountValue || enteredAmount,
                    inputHraAmount: item.inputHraAmount || hraAmount
                };
            } else {
                // If the row is not selected, keep the existing values
                return {
                    ...item,
                    inputAmountValue: "",
                    inputHraAmount: '' // Set to empty when unselected
                };
            }
        });
        setRowData(updatedData);
    }


    const setPaybill = (val) => {
        if (val === "Allowances") {
            setPaybillType("Allowances");
        } else if (val === "Deductions") {
            setPaybillType("Deductions");
        }
    }

    const PaybillTypeChange = (val) => {
        sourcingForm.setFieldsValue({ paybill: undefined });
    };

    const handlePaybillTypeChange = (val) => {
        setPaybill(val);
        PaybillTypeChange(val);
        setPaybillType(val);
    };



    const handleAmountOrPercent = (val) => {
        // setAllowPercent(false);
        setAllowAmount(false);

        setDeductAmount(false);
        if (val === "da" || val === "hra" || val === "cps" || val === "ir") {
            // setAllowPercent(true);
            setAmountPercentData(val);
        } else if (val === "pf_amount" || val === 'basic') {
            setAllowAmount(true);
            setAmountPercentData(val);
        } else if (val != "da" || val != "hra" || val != "cps" || val != "ir") {
            setAllowAmount(true);
            setAmountPercentData(val);
        } else if (val != "pf_amount" || val === 'basic') {
            // setAllowPercent(true);
            setAmountPercentData(val);
        }
    }

    // const handleDate = (val) => {
    //     setDate(true)
    //     if (val === 'da' || val === 'hra' || val === 'cps' || val === 'pf_amount' || val === 'cca' || val === "ir" || val === 'basic') {
    //         setDate(false)
    //     }
    // }

    const handleHra = (val) => {
        if (val === 'hra') {
            setHra(true)
        } else {
            setHra(false)
        }
    }

    // const handleTerm = (val) => {
    //     if (val === 'no') {
    //         setTerms(true)
    //     } else {
    //         setTerms(false)
    //     }
    // }


    const handlevalues = (val) => {
        handleAmountOrPercent(val)
        setPaybillType(val)
        handleHra(val)
    }

    // useEffect(() => {
    //     setEnteredAmount('');
    //     setHraAmount('')
    //     sourcingForm.resetFields(['amount/percent']);
    //     if (sourcingForm.getFieldValue('paybillType') === 'Allowances' ||sourcingForm.getFieldValue('empType') === "Salaried Form" ) {
    //         setPaybillOptions(Object.values(EmployeePayBillAllowanceEnum));
    //     } 
    //     if (sourcingForm.getFieldValue('paybillType') === 'Allowances' ||sourcingForm.getFieldValue('empType') === "Labour Form" ) {
    //         setPaybillOptions(Object.values(workerPayBillAllowanceEnum));
    //     }

    //     else {
    //         setPaybillOptions(Object.values(EmployeePayBillDeductionEnum));
    //     }
    // }, [sourcingForm.getFieldValue('paybillType'), paybillType, sourcingForm]);


    useEffect(() => {
        const paybillType = sourcingForm.getFieldValue('paybillType');
        const empType = sourcingForm.getFieldValue('empType');

        setEnteredAmount('');
        setHraAmount('');
        sourcingForm.resetFields(['amount/percent']);

        if (paybillType === 'Allowances') {
            if (empType === 'Salaried Form') {
                setPaybillOptions(Object.values(EmployeePayBillAllowanceEnum));
            } else if (empType === 'Labour Form') {
                setPaybillOptions(Object.values(workerPayBillAllowanceEnum));
            }
        } else {
            setPaybillOptions(Object.values(EmployeePayBillDeductionEnum));
        }
    }, [sourcingForm.getFieldValue('paybillType'), sourcingForm.getFieldValue('empType'), sourcingForm]);


    function getMonthCount(startDate, endDate) {
        var start = new Date(startDate);
        var end = new Date(endDate);
        var monthsApart = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
        return monthsApart;
    }
    const handleSave = () => {
        const transactionName = sourcingForm.getFieldValue('paybill')
        // const startMonth = new Date(sourcingForm.getFieldValue('fromDate'))
        // const permanent = sourcingForm.getFieldValue('isPermanent')
        // const termCount = sourcingForm.getFieldValue('termCount')
        // const totalTerms = sourcingForm.getFieldValue('totalTerms')
        // const monthCount = Number(Number(totalTerms) - Number(termCount)) + 1
        // const months = getYearMonthsBetween(startMonth, monthCount)
        sourcingForm
            .validateFields()
            .then((values) => {
                if (selectedRowKeys.length === 0) {
                    message.error('No checkboxes selected, handle accordingly');
                    return;
                }
                for (const data of rowData) {
                    if (data.inputAmountValue) {
                        let req1: PayrollComponentsDto;
                        // let req2: PayrollEntriesDto;
                        if (transactionName === 'basic') {
                            req1 = new PayrollComponentsDto(data.employeeId, data.inputAmountValue, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'hraAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, data.inputAmountValue, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'eduAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, data.inputAmountValue, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'medicalAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, 0, data.inputAmountValue, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'splAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, 0, 0, data.inputAmountValue, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'conveyanceAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, 0, 0, 0, data.inputAmountValue, 0, 0, 0, 0, 0, 0, 0, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'petrolAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, 0, 0, 0, 0, data.inputAmountValue, 0, 0, 0, 0, 0, 0, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'shoeAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, 0, 0, 0, 0, 0, data.inputAmountValue, 0, 0, 0, 0, 0, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'washingAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, 0, 0, 0, 0, 0, 0, data.inputAmountValue, 0, 0, 0, 0, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'uniformAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, 0, 0, 0, 0, 0, 0, 0, data.inputAmountValue, 0, 0, 0, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'helperAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, data.inputAmountValue, 0, 0, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'productionAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, data.inputAmountValue, 0, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'bonusAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, data.inputAmountValue, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'messAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, data.inputAmountValue, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'othersAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, data.inputAmountValue, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, 0, data.designation,data.departmentId,data.unitId);
                        } else if (transactionName === 'taAmount') {
                            req1 = new PayrollComponentsDto(data.employeeId, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, createdUser, data.fullName, data.employeeCode, data.employeeType, data.employeeCategory, data.inputAmountValue, data.designation,data.departmentId,data.unitId);
                        }
                        else {
                            //req2 = new PayrollEntriesDto(data.employeeId, transactionName, permanent, termCount, totalTerms, months, data.inputAmountValue, 'user')
                        }
                        if (req1) {
                            payrollService.createPayroll(req1).then((res) => {
                                if (res.status) {
                                    message.success(res.internalMessage)

                                    handleButtonReset()
                                } else {
                                    // message.error('updated')
                                }
                            })
                        } else {
                        }
                    }
                }
                // setFinishModal(true)
                sourcingForm.resetFields()
                setSelectedRowKeys([]);
                const updatedData = rowData.map((item) => ({
                    ...item,
                    inputAmountValue: "",
                }));
                setRowData(updatedData);
            }).catch((error) => {
                // Validation failed, display error messages
            });
    }

    const handleButtonReset = () => {
        sourcingForm.resetFields()
        setRowData([])

        // window.location.reload();
    }


    const displayNameMap = {
        basic: 'Basic',
        taAmount: 'TA Amount',
        hraAmount: 'Hra Amount',
        eduAmount: 'EDU Amount',
        medicalAmount: 'Medical Amount',
        splAmount: 'Spl Amount',
        conveyanceAmount: 'Conveyance Amount',
        petrolAmount: 'Petrol Amount',
        shoeAmount: 'Shoe Amount',
        washingAmount: 'Washing Amount',
        uniformAmount: 'Uniform Amount',
        helperAmount: 'Helper Amount',
        productionAmount: 'Production Amount',
        bonusAmount: 'Bonus Amount',
        messAmount: 'Mess Amount',
        othersAmount: 'Others Amount',
    };
    const handleEmployeeTypeChange = (value) => {
        sourcingForm.setFieldsValue({ category: undefined }); // Reset category when employee type changes
        setShowCategory(value === 'Labour Form');
        setDepartData([])
        fetchData(value, sourcingForm.getFieldValue('category'));
        getDepartmentByTypeOrCategory()
    };

    const handleCategoryChange = (value) => {
        fetchData(sourcingForm.getFieldValue('empType'), value);
        getDepartmentByTypeOrCategory()
    };

    const fetchData = (empType?, category?) => {
        const req = new PayrollRequestEmp(sourcingForm.getFieldValue('empType'), sourcingForm.getFieldValue('category'),sourcingForm.getFieldValue('departmentId'));
        service.getEmployeeForPayroll(req).then((res) => {
            setRowData(res.data);
        });
    };

    const getDepartmentByTypeOrCategory = () => {
        const req = new PayrollRequestEmp( sourcingForm.getFieldValue('empType'),sourcingForm.getFieldValue('category'),undefined);
        service.getDepartmentByTypeOrCategory(req).then((res) => {
            setDepartData(res.data);
        });
    };

    const departOnchange = ()=>{
        fetchData()
    }

    return (
        <div>
            <Card title={<span style={{ color: 'white', fontSize: 18 }}>Employee Payable</span>}
                style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#45c8f6', border: 0, paddingTop: "1%", paddingBottom: "1%" }} >
                <Form form={sourcingForm} layout='vertical'>
                    <Row gutter={8}>
                        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                            <Form.Item label="Employee Type" name="empType" required>
                                <Select
                                    showSearch allowClear
                                    placeholder="Select Employee Type"
                                    onChange={handleEmployeeTypeChange}
                                >
                                    <Option value="Salaried Form">Salaried Form</Option>
                                    <Option value="Labour Form">Labour Form</Option>
                                </Select>
                            </Form.Item>
                        </Col>

                        {showCategory && (
                            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                <Form.Item
                                    label="Category"
                                    name="category"
                                    rules={[{ required: true, message: 'Please select a category' }]}
                                >
                                    <Select
                                        showSearch allowClear
                                        placeholder="Select Category"
                                        onChange={handleCategoryChange}
                                    >
                                        <Option value="In-House">In-House</Option>
                                        <Option value="NMR">NMR</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 6 }}>
                            <Form.Item name='paybillType' label='PayBill Type' rules={[{ required: true, message: 'Pay Bill Type is required' }]}>
                                <Select showSearch allowClear optionFilterProp="children" placeholder='Payable Type Style'
                                    onChange={(val) => handlePaybillTypeChange(val)}
                                >
                                    {Object.values(EmployeePayBillTypeEnum).map((val) => {
                                        return (
                                            <Option key={val} value={val}>
                                                {val}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 6 }}>
                            <Form.Item name='paybill' label='Paybill' rules={[{ required: true, message: 'Paybill is required' }]}>

                                <Select showSearch allowClear optionFilterProp="children" placeholder='Select Paybill'
                                    disabled={paybillType === ""}
                                    onChange={(val) => handlevalues(val)}
                                >
                                    {paybillOptions.map((val) => (
                                        <Option key={val} value={val}>
                                            {displayNameMap[val]}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 6 }}>
                            <Form.Item name="amount/percent" label={allowAmount ? "Amount" : "Amount"} rules={[{ required: true, message: 'Amount/Percentage is required' }, {
                                pattern: /^(\d+|\d+\.\d+)$/,
                                message: `Letters , Spaces and Special charecters are not allowed`,
                            }]}>
                                <Input
                                    disabled={amountPercentData === ""}
                                    placeholder={allowAmount || deductAmount ? "enter amount" : "enter percentage/amount"}
                                    value={enteredAmount}
                                    onChange={(e) => setEnteredAmount(e.target.value)}
                                />
                            </Form.Item>
                        </Col>
                        {hra ? (<Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 6 }}>
                            <Form.Item name="amount" label='Cutoff Amount' rules={[{ required: true, message: 'Amount is required' }, {
                                pattern: /^(\d+|\d+\.\d+)$/,
                                message: `Letters , Spaces and Special charecters are not allowed`,
                            }]}>
                                <Input
                                    value={hraAmount}
                                    onChange={(e) => setHraAmount(e.target.value)}
                                />
                            </Form.Item>
                        </Col>) : null}
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 6 }}>
                            <Form.Item name='departmentId' label='Department'>
                                <Select
                                    allowClear
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder="Select Approver"
                                    onChange={departOnchange}
                                >
                                    {departData?.map((item) => (
                                    <Option
                                        key={item.departId}
                                        value={item.departId}
                                    >
                                        {item.departName}
                                    </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div style={{ textAlign: 'end', marginTop: '2%', marginRight: '5%' }}>
                    <Button onClick={handleSave}
                        style={{
                            backgroundColor: selectedRowKeys.length > 0 ? "#0d0d8e" : "#ccc",
                            color: "white",
                            marginTop: '40px',
                            marginBottom: '10px',
                            textAlign: "right",
                            border: selectedRowKeys.length > 0 ? "none" : "1px solid #ccc",
                            marginRight: '1%'
                        }}
                        disabled={selectedRowKeys.length === 0}
                    >Save</Button>
                    <Button onClick={handleButtonReset} style={{ backgroundColor: "red", color: 'white' }} >Reset</Button>
                </div>
                <Table
                    rowSelection={{
                        type: 'checkbox',
                        selectedRowKeys: selectedRowKeys,
                        onChange: handleRowSelection,


                    }}
                    rowKey={(record) => record.employeeId}
                    columns={columns}
                    dataSource={rowData}
                    style={{ marginTop: "2%" }}
                    pagination={false}
                    scroll={{ y: 600 }}
                />
                <Modal
                    className='qr-container'
                    key={'modall' + Date.now()}
                    width={'50%'}
                    style={{ top: 50, alignContent: 'center' }}
                    visible={finishModal}
                    onOk={() => { setFinishModal(false) }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                    title={<React.Fragment>
                    </React.Fragment>}
                >
                    <p><b>Saved Successfully</b></p>

                </Modal>
            </Card>
        </div >
    )
}

export default EmployeePayable;